export const INITIALIZATION = "/";
export const ONBOARDING = "/onboarding";
export const CHOOSE_SUPERVISOR_TYPE = "/choose_supervisor_type";
export const BUSINESS_REGISTRATION = "/business_registration";
export const PERSON_REGISTRATION = "/person_registration";
export const HOME = "/";
export const SCANNER = "/scanner";
export const TEST_RESULT_PREVIEW = "/test_result_preview";
export const DATA_PRIVACY = "/data_privacy";
export const GET_HELP = "/get_help";
export const TEST_PHOTO = "/test_photo";
export const HISTORY = "/history";
